import axios from 'axios';
import { loginreq, jsonreq, req } from './axiosFun';

export const login = (params) => { return loginreq("post", "/aimed-api/admin/account/login", params) };
export const logout = (params) => { return loginreq("post", "/shicheng/login/logout", params) };

export const loadMeridianList = (params) => { return req("post", "/aimed-api/admin/meridian/reportList", params) };
export const rePushMeridian = (params) => { return req("post", "/aimed-api/admin/meridian/push2App", params) };
export const recalculate = (params) => { return req("post", "/aimed-api/admin/meridian/recalculate", params) };
export const compareMeridian = (params) => { return req("post", "/aimed-api/admin/meridian/compare", params) };
export const loadTongueList = (params) => { return req("post", "/aimed-api/admin/tongue/reportList", params) };
export const loadPhysiqueList = (params) => { return req("post", "/aimed-api/admin/physique/reportList", params) };
export const loadApp = (params) => { return req("post", "/aimed-api/admin/app/list", params) };
export const deleteApp = (params) => { return req("post", "/aimed-api/admin/app/delete", params) };
export const enableApp = (params) => { return req("post", "/aimed-api/admin/app/enable", params) };
export const setAppLimit = (params) => { return req("post", "/aimed-api/admin/app/setLimitField", params) };
export const loadUser = (params) => { return req("post", "/aimed-api/admin/user/list", params) };
export const saveOrUpdateApp = (params) => { return jsonreq("/aimed-api/admin/app/saveOrUpdate", params) };
export const loadCombination = (params) => { return req("post", "/aimed-api/admin/combination/list", params) };

export const physiqueAiAnalyze = (params) => { return req("post", "/aimed-api/admin/physique/aiAnalyze", params) };
export const tongueAiAnalyze = (params) => { return req("post", "/aimed-api/admin/tongue/aiAnalyze", params) };
export const meridianAiAnalyze = (params) => { return req("post", "/aimed-api/admin/meridian/aiAnalyze", params) };


/*下面这些不是当前项目用的，但有无用的代码引用到，待无用代码也删除后，下面这些也一起删*/
export const tutorList = (params) => { return req("post", "/shicheng/admin/tutor/list", params) };
export const allTutor = (params) => { return req("post", "/shicheng/admin/tutor/allTutor", params) };
export const tutorDelete = (id) => { return req("get", "/shicheng/admin/tutor/delete?id="+id, {}) };
export const tutorDisable = (params) => { return req("post", "/shicheng/admin/tutor/disable", params) };

export const signUpList = (params) => { return req("post", "/shicheng/admin/signUp/list", params) };
export const signUpDelete = (id) => { return req("get", "/shicheng/admin/signUp/delete?id="+id, {}) };
export const signUpOperation = (params) => { return jsonreq("/shicheng/admin/signUp/operation", params) };

export const tutorWorkList = (params) => { return req("post", "/shicheng/admin/tutor/workList", params) };
export const tutorWorkState = (params) => { return req("post", "/shicheng/admin/tutor/workState", params) };
export const tutorWorkSaveUpdate = (params) => { return jsonreq("/shicheng/admin/tutor/saveOrUpdateWork", params) };

export const schoolList = (params) => { return req("post", "/shicheng/admin/school/list", params) };
export const schoolState = (params) => { return req("post", "/shicheng/admin/school/state", params) };
export const schoolSaveUpdate = (params) => { return jsonreq("/shicheng/admin/school/saveOrUpdate", params) };

export const userList = (params) => { return req("post", "/shicheng/admin/user/list", params) };
export const userSimpleList = (params) => { return req("post", "/shicheng/admin/user/simpleList", params) };

export const tutorBusinessSaveUpdate = (params) => { return jsonreq("/shicheng/admin/tutor/saveOrUpdateBusiness", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js